import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChatsCircle, Copy } from "@phosphor-icons/react";
import { api, LANGS } from "@/lib/api";
import { AppHead, usePropertyList } from "@/pages/app/Dashboard";
import { PropertyPicker, useAiCall } from "@/pages/app/Rewriter";
import { useT } from "@/i18n";

const TYPES = ["booking confirmation", "pre-arrival", "check-in", "mid-stay", "checkout", "review request"];

export default function Messages() {
  const { t, lang } = useT();
  const [props] = usePropertyList();
  const [f, setF] = useState({ message_type: "check-in", property_desc: "", lang: lang === "it" ? "Italian" : "English" });
  const [lib, setLib] = useState([]);
  const [busy, call] = useAiCall();
  const loadLib = () => api.get("/generations?kind=message").then((r) => setLib(r.data));
  useEffect(() => { loadLib(); }, []);

  const run = async (e) => {
    e.preventDefault();
    const d = await call("/ai/message", f);
    if (d) { setLib([d, ...lib]); toast.success(t("Message added to your library")); }
  };

  return (
    <div data-testid="messages-page">
      <AppHead title="Guest message library" sub="Short, warm messages in 10 languages. Placeholders like {guest_name} stay ready to fill." />
      <form onSubmit={run} className="card p-6 bg-white grid md:grid-cols-[1fr_1fr_1.5fr_auto] gap-3 items-end" data-testid="message-form">
        <div><span className="label">{t("Message")}</span><select className="field" value={f.message_type} onChange={(e) => setF({ ...f, message_type: e.target.value })} data-testid="message-type-select">{TYPES.map((o) => <option key={o} value={o}>{t(o)}</option>)}</select></div>
        <div><span className="label">{t("Language")}</span><select className="field" value={f.lang} onChange={(e) => setF({ ...f, lang: e.target.value })} data-testid="message-lang-select">{LANGS.map((o) => <option key={o} value={o}>{t(o)}</option>)}</select></div>
        <div><span className="label">{t("Property")}</span><input required minLength={3} className="field" value={f.property_desc} onChange={(e) => setF({ ...f, property_desc: e.target.value })} placeholder={t("Casa Azul, 2-bed flat in Valencia, key box at door")} data-testid="message-property-input" /></div>
        <button disabled={busy} className="btn-coral justify-center" data-testid="message-generate-btn"><ChatsCircle size={18} weight="fill" /> {busy ? t("Writing…") : t("Write")}</button>
        <div className="md:col-span-4"><PropertyPicker props={props} onPick={(p) => p && setF({ ...f, property_desc: `${p.name}, ${p.property_type} in ${p.city}, ${p.country}` })} /></div>
      </form>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4 mt-6" data-testid="message-library">
        {busy && <div className="card p-6 bg-white space-y-2"><div className="skeleton h-4 w-1/3" /><div className="skeleton h-4" /><div className="skeleton h-4 w-5/6" /></div>}
        {lib.length === 0 && !busy && <p className="text-gray-500">{t("No messages yet.")}</p>}
        {lib.map((m) => (
          <div key={m.gen_id} className="card p-6 bg-white flex flex-col" data-testid={`message-card-${m.gen_id}`}>
            <div className="flex justify-between items-center">
              <span className="text-xs font-semibold uppercase tracking-wider text-[#0F4C5C]">{t(m.input.message_type)} · {t(m.input.lang)}</span>
              <button onClick={() => { navigator.clipboard.writeText(m.output.text); toast.success(t("Copied")); }} className="text-[#0F4C5C] hover:text-[#E36414]" data-testid={`message-copy-${m.gen_id}`}><Copy size={18} /></button>
            </div>
            <p className="mt-3 text-sm text-gray-800 whitespace-pre-wrap flex-1">{m.output.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
